import axios from "axios";
import { request, errorText, openBlob } from "../api";

// /api/accounting/tax/*
const base = `${process.env.REACT_APP_BACKEND_URL}/accounting/tax`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

export const getMeta = () => request.get("/tax/meta");

export const ustvaPeriods = year => request.get("/tax/ustva/periods", { year });
export const ustvaPeriod = (period, params) => request.get(`/tax/ustva/${period}`, params);
export const prepareUstva = (period, body) =>
  request.post(`/tax/ustva/${period}/prepare`, body || {});

export const listFilings = params => request.get("/tax/filings", params);
export const getFiling = id => request.get(`/tax/filings/${id}`);
/** POST that answers with the XML file (blob). */
export const exportXml = id =>
  axios.post(`${base}/filings/${id}/xml`, {}, { ...headers(), responseType: "blob" });
export const transmit = (id, pin) => request.post(`/tax/filings/${id}/transmit`, { pin });
export const markTransmitted = (id, transferTicket) =>
  request.post(`/tax/filings/${id}/mark-transmitted`, { transferTicket });
export const correct = (id, body) => request.post(`/tax/filings/${id}/correct`, body || {});

export const dauerfristPreview = year => request.get(`/tax/dauerfrist/${year}`);
export const prepareDauerfrist = (year, body) =>
  request.post(`/tax/dauerfrist/${year}`, body || {});

export const zmPreview = period => request.get(`/tax/zm/${period}`);
export const prepareZm = period => request.post(`/tax/zm/${period}/prepare`);

export const bauabzugsteuerPreview = period => request.get(`/tax/bauabzugsteuer/${period}`);
export const prepareBauabzugsteuer = period =>
  request.post(`/tax/bauabzugsteuer/${period}/prepare`);
export const freistellungCheck = (supplierId, online) =>
  request.get(`/tax/bauabzugsteuer/freistellung/${supplierId}`, online ? { online: 1 } : undefined);

export const kleinunternehmerStatus = year =>
  request.get("/tax/kleinunternehmer", year ? { year } : undefined);

export const getElsterSettings = () => request.get("/tax/elster-settings");
export const updateElsterSettings = body => request.put("/tax/elster-settings", body);

/** Downloads the XML of a filing with the server's filename. */
export const downloadXml = async (id, filename) => openBlob(exportXml(id), filename);

export { errorText };
